// The current step is never stored — it's recomputed from the data, so going
// backwards is free (add an unscaled page at step 4 and it drops to 1 itself).
// FrameXPanel owns what each step *means*; this only ranks them.

/**
 * The first step in the ladder that isn't satisfied.
 * @param {{ step1Done: boolean, step2Done: boolean, step3Done: boolean }} done
 * @returns {1|2|3|4}
 */
export function deriveCurrentStep({ step1Done, step2Done, step3Done }) {
  if (!step1Done) return 1;
  if (!step2Done) return 2;
  if (!step3Done) return 3;
  return 4;
}
